import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

interface MarkdownRendererProps {
  children: string;
  className?: string;
}

/**
 * A wrapper component for ReactMarkdown that supports HTML tags
 * Uses rehype-raw plugin to parse and render HTML within markdown
 * 
 * Note: This component renders markdown content that may contain raw HTML.
 * Ensure content is from trusted sources to prevent XSS vulnerabilities.
 */
export const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({
  children,
  className,
}) => {
  // For markdown content (with potential HTML tags), use ReactMarkdown
  return (
    <div className={className}>
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>{children}</ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
